import FlipCountdown from '@rumess/react-flip-countdown';

import './css/FlipperClock.css';

function FlipperClock({ boardEndTime, setScoreFlag, setClockFlag }) {

    const timeUp = () => {
        setScoreFlag(false);
        setClockFlag(false);
    };

    return (
        <FlipCountdown
            size='extra-small'
            theme='light'
            endAt={boardEndTime}
            onTimeUp={timeUp}
            hideYear
            hideMonth
            hideDay
        />
    );

}

export default FlipperClock;